import React from 'react';
import uiStyles from '../../theme/uiStyles';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo);
    }

    // Could send to error reporting service here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          ...uiStyles.card,
          textAlign: 'center',
          maxWidth: '500px',
          margin: '50px auto'
        }}>
          <h2>Oops! Something went wrong</h2>
          <p>We're sorry, but something unexpected happened. Please try refreshing the page.</p>

          <button
            onClick={() => window.location.reload()}
            style={{
              ...uiStyles.primaryBtn,
              marginTop: '20px'
            }}
          >
            Refresh Page
          </button>

          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '20px', textAlign: 'left' }}>
              <summary>Error Details (Development)</summary>
              <pre style={{
                background: '#f5f5f5',
                padding: '10px',
                borderRadius: '4px',
                fontSize: '12px',
                overflow: 'auto',
                marginTop: '10px'
              }}>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;